import styled from 'styled-components';

export default styled.div`
  display: block;
  line-height: 1.7;
  font-size: 13px;
  padding: 0;
  background: none;
  border: none;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.linkColor};
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/GenericTooltip/LinkButton.jsx